<template>
  <div ref="scrollDiv" id="scrollDiv">

    <!--    <el-dialog title="tip" :visible.sync="isLoading" size="tiny" :append-to-body="true" :show-close="false">-->
    <!--      <span style="margin-left: 45%">loading data</span>-->
    <!--&lt;!&ndash;      <img src="src/assets/loading.gif" height="300px" width="300px">&ndash;&gt;-->
    <!--    </el-dialog>-->
    <div id="dataset_introduce">
      <h2>Cancer Type Introduction</h2>
      <el-image :src="icon_path" v-on:click="showOrHide"
                style="position: absolute;width: 30px;height:30px;right: 10px;top:0;z-index: 9999"/>
      <div class="introduction" v-show="showIntroduction">
        <div class="left_introduction">
          <el-menu :default-active="active.toString()" class="el-menu-vertical-demo" @select="handleSelect">
            <el-menu-item index="0">
              <span slot="title"><b>Breast cancer</b></span>
            </el-menu-item>
            <el-menu-item index="1">
              <span slot="title"><b>PDAC</b></span>
            </el-menu-item>
            <el-menu-item index="2">
              <span slot="title"><b>Skin cancer</b></span>
            </el-menu-item>
            <el-menu-item index="3">
              <!--            <i class="el-icon-view"></i>-->
              <span slot="title"><b>Melanoma</b></span>
            </el-menu-item>
            <el-menu-item index="4">
              <span slot="title"><b>Prostate cancer</b></span>
            </el-menu-item>
            <el-menu-item index="5">
              <span slot="title"><b>Liver cancer</b></span>
            </el-menu-item>
            <el-menu-item index="6">
              <span slot="title"><b>Ovarian cancer</b></span>
            </el-menu-item>
            <el-menu-item index="7">
              <span slot="title"><b>Glioblastoma</b></span>
            </el-menu-item>
            <el-menu-item index="8">
              <span slot="title"><b>Colorectal Cancer</b></span>
            </el-menu-item>
            <el-menu-item index="9">
              <span slot="title"><b>Cervical Cancer</b></span>
            </el-menu-item>
            <!--            <el-menu-item index="10">-->
            <!--              <span slot="title"><b>Intestine Cancer</b></span>-->
            <!--            </el-menu-item>-->
            <el-menu-item index="11">
              <span slot="title"><b>Bladder Cancer</b></span>
            </el-menu-item>
            <el-menu-item index="12">
              <span slot="title"><b>Brain metastases</b></span>
            </el-menu-item>
            <el-menu-item index="13">
              <span slot="title"><b>Lung cancer</b></span>
            </el-menu-item>
            <el-menu-item index="14">
              <span slot="title"><b>Head and neck cancer</b></span>
            </el-menu-item>
          </el-menu>
        </div>
        <div class="right_introduction">
          <h3>
            {{ datasetName[active] }}
          </h3>
          <div style="text-align: justify;word-spacing: 5px;line-height: 25px;font-size: 16px;margin: 5px;color: black">
            {{ description[active] }}
          </div>
          <img :src="pic_path[active]" alt="pic error">
          <!-- 150 180 120 150-->
          <div style="white-space: pre; height: 50px;float: bottom">{{ cite[active] }}</div>
        </div>
      </div>
    </div>
    <div id="cancer_checkbox">
      <h2>Select Cancer Type</h2>
      <div class="CheckBox">
        <div class="CheckItem" v-for="(item,index) in cancers" :key="index">
          <div :class="['select',selectedCancer.includes(item)?'selectActv':'']"
               @click="selectFun(item)"></div>
          <span>{{ item }}</span>
        </div>
      </div>
      <div style="margin: 20px">
        <p style="text-align: left;">
          <b>Selected:</b>
          <span v-for="(item,index) in ChooseList" :key="index" style="margin: 10px">
          {{ item }}
        </span>
        </p>
      </div>
      <div id="search_result">
        <h3 style="float: left;margin-left: 20px">
          return {{ dataset_search_result_list.length }} datasets
        </h3>
        <div style="float: right;margin: 10px 50px 0 0">
          <el-button size="mini" type="info" round id="disable_button" style="display: block" disabled>
            <span style="font-size: 20px">
              submit
            </span>
          </el-button>
          <el-button size="mini" type="info" round id="search_result_button_submit" style="display: none"
                     @click="click_submit">
            <span style="font-size: 20px">
              submit
            </span>
          </el-button>
          <el-button size="mini" type="info" round id="search_result_button_compare" style="display: none"
                     @click="click_compare">
            <span style="font-size: 20px">
              compare
            </span>
          </el-button>
        </div>
        <el-table
            height="400"
            type="selection"
            :data="dataset_search_result_list"
            stripe
            :row-style="{height: '30px'}"
            :cell-style="{padding: '0', color: 'black', margin: '0'}"
            :header-cell-style="{color: 'black'}"
            @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column prop="datasetname" label="Dataset" sortable show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="name" label="Sample" sortable show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="title" label="Title" sortable show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="journal" label="Journal" sortable show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="type" label="Type" sortable show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="year" label="Year" sortable show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="pmid" label="PMID" sortable>
            <template slot-scope="scope">
              <a target="_blank" class="buttonText" :href="gotoDetails(scope.row.pmid)">{{ scope.row.pmid }}</a>
            </template>
          </el-table-column>
        </el-table>
        <!--        <el-pagination align='center' @size-change="handleSizeChange" @current-change="handleCurrentChange"-->
        <!--                       :current-page="currentPage"-->
        <!--                       :page-sizes="[1,5,10,20]"-->
        <!--                       :page-size="pageSize"-->
        <!--                       layout="total, sizes, prev, pager, next, jumper"-->
        <!--                       :total="dataset_search_result_list.length">-->
        <!--        </el-pagination>-->
      </div>
    </div>
    <div id="dataset_detail" v-show="showDatasetDetail">
      <h2>Dataset Analysis</h2>
      <el-tabs v-model="activeName" type="card" stretch @tab-click="handleClick">
        <div style="margin-left: 0; margin-top: 0; position: absolute; z-index: 10"
             :key="key_AllLabelChart">
          <AllLabelChart :asyn-ground="groundtruth_dataset"
                         :datasetInfo="selectedDataset"
                         :asyn-annot="echart_info.annot_type_info"
                         :asyn-fine-anno="echart_info.fine_annot_type_info"
                         :asyn-classification="echart_info.classification_info"
                         :asyn-celltype="echart_info.celltype_info"
                         :asyn-major="echart_info.major_info"
                         :asyn-minor="echart_info.minor_info"
                         :asyn-subset="echart_info.subset_info"
                         v-show="showChart"/>
        </div>
        <el-tab-pane label="Overview" name="first" :lazy="true" :key="key_overview">
          <Overview_grid :asyncData="echart_info" :datasetInfo="selectedDataset" :asynGround="groundtruth_dataset"
                         @scrollToBottom="scrollToBottom"/>
<!--          <Overview2 :asyncData="echart_info" :datasetInfo="selectedDataset" :asynGround="groundtruth_dataset"-->
<!--                     @scrollToBottom="scrollToBottom"></Overview2>-->
        </el-tab-pane>
        <el-tab-pane name="gene-level" :lazy="true" :key="key_gene">
          <span slot="label">
            <el-dropdown @command="handleCommand" @click="handleCommand">
              <span class="el-dropdown-link" style="color: black;">
                Gene Level Analysis
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="marker">Marker</el-dropdown-item>
                <el-dropdown-item command="svg">SVGs</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </span>
<!--          <Dataset_Marker-->
<!--              v-show="show_marker"-->
<!--              :asyncData="echart_info"-->
<!--              :asynGround="groundtruth_dataset"-->
<!--              :datasetInfo="selectedDataset"-->
<!--              :position_main="position"/>-->
<!--          <Dataset_SVG-->
<!--              v-show="show_svg"-->
<!--              :asyncData="echart_info"-->
<!--              :asynGround="groundtruth_dataset"-->
<!--              :datasetInfo="selectedDataset"-->
<!--              :position_main="position"/>-->
          <Dataset_Marker_grid
              v-show="show_marker"
              :asyncData="echart_info"
              :asynGround="groundtruth_dataset"
              :datasetInfo="selectedDataset"
              :position_main="position"/>
          <Dataset_SVG_grid
              v-show="show_svg"
              :asyncData="echart_info"
              :asynGround="groundtruth_dataset"
              :datasetInfo="selectedDataset"
              :position_main="position"/>
        </el-tab-pane>
<!--        <el-tab-pane label="SVGs" name="third" :lazy="true" :key="key_svg">-->
<!--          <Dataset_SVG :asyncData="echart_info" :asynGround="groundtruth_dataset" :datasetInfo="selectedDataset"-->
<!--                       :position_main="position"></Dataset_SVG>-->
<!--        </el-tab-pane>-->

        <el-tab-pane name="cell-level" :lazy="true" :key="key_cell">
          <span slot="label">
            <el-dropdown @command="handleCommand2" @click="handleCommand2">
              <span class="el-dropdown-link" style="color: black;">
                Cell Level Analysis
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="celltype">Cell Type Annotation</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </span>
          <Dataset_celltype_grid
              v-show="show_celltype"
              :asyncData="echart_info"
              :asynGround="groundtruth_dataset"
              :datasetInfo="selectedDataset"
              :source-data="data"
              :source-position="position"/>
<!--          <Dataset_celltype-->
<!--              v-show="show_celltype"-->
<!--              :asyncData="echart_info"-->
<!--              :asynGround="groundtruth_dataset"-->
<!--              :datasetInfo="selectedDataset"-->
<!--              :source-data="data"-->
<!--              :source-position="position"/>-->
        </el-tab-pane>
<!--        <el-tab-pane label="Cell Type Annotation" name="fifth" :lazy="true" :key="key_celltype">-->
<!--          <Dataset_celltype :asyncData="echart_info" :asynGround="groundtruth_dataset" :datasetInfo="selectedDataset"-->
<!--                            :source-data="data" :source-position="position"></Dataset_celltype>-->
<!--        </el-tab-pane>-->
<!--        <el-tab-pane label="Cell Malignancy Estimation" name="sixth" :lazy="true" :key="key_cnv">-->
<!--          <Dataset_CNV :datasetInfo="selectedDataset" :asynGround="groundtruth_dataset" :source-data="data"-->
<!--                       :source-position="position"></Dataset_CNV>-->
<!--        </el-tab-pane>-->
        <el-tab-pane name="cancer-level" :lazy="true" :key="key_cancer">
          <span slot="label">
            <el-dropdown @command="handleCommand3" @click="handleCommand3">
              <span class="el-dropdown-link" style="color: black;">
                Cancer Level Analysis
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="cnv">Tumor malignancy estimation</el-dropdown-item>
                <el-dropdown-item command="state">Cancer functional states evaluation</el-dropdown-item>
                <el-dropdown-item command="immune">Immune component characterization</el-dropdown-item>
                <el-dropdown-item command="tls">TLS Analysis</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </span>
<!--          <Dataset_CNV-->
<!--              v-show="show_cnv"-->
<!--              :datasetInfo="selectedDataset"-->
<!--              :asynGround="groundtruth_dataset"-->
<!--              :source-data="data"-->
<!--              :source-position="position"/>-->
<!--          <Dataset_state-->
<!--              v-show="show_state"-->
<!--              :asyncData="echart_info"-->
<!--              :asynGround="groundtruth_dataset"-->
<!--              :datasetInfo="selectedDataset"/>-->
<!--          <Dataset_immune-->
<!--              v-show="show_immune"-->
<!--              :datasetInfo="selectedDataset"-->
<!--          />-->
<!--          <Dataset_TLS-->
<!--              v-show="show_tls"-->
<!--              :datasetInfo="selectedDataset"/>-->
          <Dataset_CNV_grid
              v-show="show_cnv"
              :datasetInfo="selectedDataset"
              :asynGround="groundtruth_dataset"
              :source-data="data"
              :source-position="position"/>
          <Dataset_state_grid
              v-show="show_state"
              :asyncData="echart_info"
              :asynGround="groundtruth_dataset"
              :datasetInfo="selectedDataset"/>
          <Dataset_immune_grid
              v-show="show_immune"
              :asyncData="echart_info"
              :asynGround="groundtruth_dataset"
              :datasetInfo="selectedDataset"/>
          <Dataset_TLS_grid
            v-show="show_tls"
            :asyncData="echart_info"
            :asynGround="groundtruth_dataset"
            :position="position"
            :datasetInfo="selectedDataset"/>
        </el-tab-pane>
<!--        <el-tab-pane label="Cancer State Score" name="seventh" :lazy="true" :key="key_state">-->
<!--          <Dataset_state :asyncData="echart_info" :asynGround="groundtruth_dataset"-->
<!--                         :datasetInfo="selectedDataset"></Dataset_state>-->
<!--        </el-tab-pane>-->
      </el-tabs>
    </div>
    <div id="compare" v-show="showDatasetCompare">
      <Compare :datasetInfo="selectedDataset" :key="refresh_tag_compare"></Compare>
    </div>
  </div>
</template>

<script>
// import Overview2 from "@/components/Dataset/Overview2";
// import Dataset_Marker from "@/components/Dataset/Dataset_Marker";
// import Dataset_SVG from "@/components/Dataset/Dataset_SVG";
// import Dataset_celltype from "@/components/Dataset/Dataset_celltype";
// import Dataset_CNV from "@/components/Dataset/Dataset_CNV";
// import Dataset_state from "@/components/Dataset/Dataset_state";
// import Dataset_immune from "@/components/Dataset/Dataset_immune";
// import Dataset_TLS from "@/components/Dataset/Dataset_TLS";
import Compare from "@/components/Dataset/Compare";
import Dataset_SVG_grid from "@/components/Dataset/Dataset_SVG_grid";

import description_json from '../../assets/Dataset/dataset_introduction.json'
import Overview_grid from "@/components/Dataset/Overview_grid";
import Dataset_Marker_grid from "@/components/Dataset/Dataset_Marker_grid";
import Dataset_celltype_grid from "@/components/Dataset/Dataset_celltype_grid";
import Dataset_CNV_grid from "@/components/Dataset/Dataset_CNV_grid";
import Dataset_state_grid from "@/components/Dataset/Dataset_state_grid";
import Dataset_immune_grid from "@/components/Dataset/Dataset_immune_grid";
import Dataset_TLS_grid from "@/components/Dataset/Dataset_TLS_grid";

const CancerTypeList = ['Breast Cancer', 'PDAC', 'SCC', 'Melanoma', 'Prostate Cancer', 'Liver Cancer', 'Ovarian Cancer', 'Glioblastoma',
  'Colorectal Cancer', 'Cervical Cancer', 'Bladder Cancer', 'Brain metastases', 'Lung Cancer', 'Head and neck Cancer'];
export default {
  name: "Dataset",
  components: {
    Dataset_TLS_grid,
    Dataset_immune_grid,
    Dataset_state_grid,
    Dataset_CNV_grid,
    Dataset_celltype_grid,
    Dataset_SVG_grid,
    Dataset_Marker_grid,
    Overview_grid,
    // Overview2, Dataset_Marker, Dataset_SVG, Dataset_celltype, Dataset_CNV, Dataset_state, Dataset_immune, Dataset_TLS
    Compare},
  data() {
    return {
      // cancer introduction
      showIntroduction: true,
      icon_path: require('../../assets/hide.png'),
      active: 0,
      datasetName: ["BreastCancer", "PDAC", "SkinCancer", "Melanoma", "ProstateCancer",
        "LiverCancer", "OvarianCancer", "Glioblastoma", "ColorectalCancer", "CervicalCancer",
        "IntestineCancer", "BladderCancer", "Brainmetastases", "LungCancer", "HeadAndNeckCancer"],
      description: [
        description_json.BreastCancer,
        description_json.PDAC,
        description_json.SkinCancer,
        description_json.Melanoma,
        description_json.ProstateCancer,
        description_json.LiverCancer,
        description_json.OvarianCancer,
        description_json.Glioblastoma,
        description_json.ColorectalCancer,
        description_json.CervicalCancer,
        "",
        description_json.BladderCancer,
        description_json.BrainMetastases,
        description_json.LungCancer,
        description_json.HeadAndNeckCancer
      ],
      pic_path: [
        require("@/assets/Dataset/202101.png"),
        require("@/assets/Dataset/202102.png"),
        require("@/assets/Dataset/202103.png"),
        require("@/assets/Dataset/202104.png"),
        require("@/assets/Dataset/202105.png"),
        require("@/assets/Dataset/202106.png"),
        require("@/assets/Dataset/202107.png"),
        require("@/assets/Dataset/202108.png"),
        require("@/assets/Dataset/202109.png"),
        require("@/assets/Dataset/202110.jpg"),
        require("@/assets/Dataset/202111.jpg"),
        require("@/assets/Dataset/202112.jpg"),
        require("@/assets/Dataset/202113.jpg"),
        require("@/assets/Dataset/202114.png"),
        require("@/assets/Dataset/202115_200height.png")
      ],
      cite: [
        "Mapping breast cancer heterogeneity using SRT.\n Sunny Z. Wu et al. Nature Genetics. 2021.",
        "Annotated PDAC tumor cryosection on the ST slide.\n Reuben Moncada et al. Nature Biotechnology. 2020.",
        "Hematoxylin and eosin (H&E) staining of tissue sections and unbiased clustering of ST spots.\n Andrew L. Ji et al. Cell. 2020.",
        "H&E-stained tissue image with pathologic annotation.\n Thrane et al. Cancer Research. 2018.",
        "Annotated brightfield image of H&E-stained tissue section.\n Emelie Berglund et al. Nature Communications. 2018.",
        "H&E staining of malignant and non-malignant sites from patient p4, separated by the white dashed line. Scale bar is 100 µm.\n Thrane et al. Molecular Systems Biology. 2020.",
        "Immunofluorescent image with pathologic annotation.\n Thrane et al. Cancer Research. 2018.",
        "H&E-stained tissue image with pathologic annotation.\n Vidhya M. Ravi et al. bioRxiv. 2021.",
        "The spatial transcriptomics of selected immune cell subsets in colon or liver tumor-normal samples.\n Yingcheng Wu et al. Cancer Discovery. 2022.",
        "H&E-stained tissue image with pathologic annotation.\n baidu.com",
        "H&E-stained tissue image with pathologic annotation.\n baidu.com 2021.",
        "H&E-stained tissue image with pathologic annotation.\n Ashish M Kamat, Noah M Hahn et al. 2016.",
        "H&E-stained tissue image with pathologic annotation.\n William H.Hudson, Lisa J.Sudmeier bioRxiv. 2021.",
        "H&E-stained tissue image with pathologic annotation.\n Li Zhang et al. bioRxiv. 2021.",
        "NATION CANCER INSTITUTE \n https://www.cancer.gov/types/head-and-neck/head-neck-fact-sheet"
      ],
      //select cancer
      selectedCancer: [],
      cancers: CancerTypeList,
      selectedDataset: [],
      dataset_search_result_list: [],
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      activeName: '',
      key_submit_num: 0,
      key_AllLabelChart: 'AllLabelChart',
      key_overview: 'overview',
      key_gene: 'gene',
      key_cell: 'cell',
      key_cancer: 'cancer',
      key_marker: 'marker',
      key_svg: 'svg',
      key_celltype: 'celltype',
      key_cnv: 'cnv',
      key_state: 'state',
      show_marker: true,
      show_svg: false,
      show_celltype: true,
      show_cnv: true,
      show_state: false,
      show_immune: false,
      show_tls: false,
      showDatasetDetail: false,
      showDatasetCompare: false,
      // loadChart: false,
      showChart: false,
      refresh_tag_compare: +new Date(),
      data: [],
      position: [],
      COLOR_ALL: [
        '#37A2DA',
        '#e06343',
        '#37a354',
        '#b55dba',
        '#b5bd48',
        '#8378EA',
        '#96BFFF',
        '#E72178',
        '#354E6C', '#EAAC31',
        '#EAD2AE',
        '#127678', '#30B5A4', '#B4D9D2',
        '#354581', '#FFE074',
        '#E03C79', '#88C1B8',
        '#FC6746', '#F5B307', '#008186'
      ],
      groundtruth_dataset: '',
      echart_info: {
        classification_info: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        },
        annot_type_info: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        },
        fine_annot_type_info: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        },
        celltype_info: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        },
        major_info: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        },
        minor_info: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        },
        subset_info: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        }
      },
    };
  },
  created() {
    this.getRouterData()
  },
  computed: {
    // 被选中项的集合
    ChooseList() {
      return this.selectedCancer.filter((item) => {
        if (this.selectedCancer.includes(item)) {
          return item
        }
      })
    },
  },
  mounted() {
    // this.hide_dataset_detail()
    // this.hide_compare()
    // this.readjson()
  },
  methods: {
    getRouterData() {
      let _this = this
      let name = _this.$route.params.type
      // console.log('name', name)
      if (name === undefined) {
        _this.active = 0
      } else {
        _this.active = _this.datasetName.indexOf(name)
        // console.log('active', _this.active)
      }
    },
    getGroundTruth() {
      let _this = this
      _this.$axios.get(
          'http://' + _this.$global.serverIP + ':' + _this.$global.serverHost + '/dataset/groundtruth/'
          + _this.selectedDataset[0].datasetID + '/' + _this.selectedDataset[0].name)
          .then(function (response) {
            _this.groundtruth_dataset = response.data
            console.log("groundtruth:" + _this.groundtruth_dataset)
          })
    },
    getAnnoAndPositionData() {
      let _this = this
      return new Promise((resolve, reject) => {
        _this.$axios.get(
            'http://' + _this.$global.serverIP + ':' + _this.$global.serverHost + '/dataset/anno_position/'
            + _this.selectedDataset[0].datasetID + '/' + _this.selectedDataset[0].name)
            .then(function (response) {
              // console.log(_this.selectedDataset[0].datasetID)
              // console.log(_this.selectedDataset[0].name)
              console.log(response)
              _this.data = JSON.parse(response.data.anno)
              _this.position = JSON.parse(response.data.position)
              console.log(_this.data)
              // console.log(_this.position)
              // _this.data = eval('(' + response.data.anno + ')')
              // _this.position = eval('(' + response.data.position + ')')
              // console.log(_this.data)
              // console.log(_this.position)
              _this.clearData()
              let haveClassification = Object.prototype.hasOwnProperty.call(_this.data[0], "Classification")
              let haveAnnot = Object.prototype.hasOwnProperty.call(_this.data[0], "annot_type")
              let haveFineAnnot = Object.prototype.hasOwnProperty.call(_this.data[0], "fine_annot_type")
              let haveCelltype = Object.prototype.hasOwnProperty.call(_this.data[0], "celltype")
              let haveMajor = Object.prototype.hasOwnProperty.call(_this.data[0], "celltype_major")
              let haveMinor = Object.prototype.hasOwnProperty.call(_this.data[0], "celltype_minor")
              let haveSubset = Object.prototype.hasOwnProperty.call(_this.data[0], "celltype_subset")
              let haveX = Object.prototype.hasOwnProperty.call(_this.data[0], "x")
              let haveY = Object.prototype.hasOwnProperty.call(_this.data[0], "y")
              // console.log(haveAnnot)
              // console.log(haveFineAnnot)
              // console.log(haveClassification)
              // console.log(haveCelltype)
              // console.log(haveMajor)
              // console.log(haveMinor)
              // console.log(haveSubset)
              if(haveX && haveY){
                _this.initEchartsInfoWithPosition(haveAnnot, haveFineAnnot, haveClassification, haveCelltype, haveMajor, haveMinor, haveSubset)
              }else {
                _this.initEchartsInfo(haveAnnot, haveFineAnnot, haveClassification, haveCelltype, haveMajor, haveMinor, haveSubset)
              }
              // _this.initEchartsInfoLabel(haveAnnot, haveFineAnnot, haveClassification)
              // _this.initEchartsInfoPre(haveCelltype, haveMajor, haveMinor, haveSubset)
              resolve()
            }).catch(function () {
          reject()
        })
      });
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath)
      this.active = key
      // this.$router.replace("/Dataset/type/" + this.datasetName[key])
      // console.log(this.$route.fullPath)
      // console.log(this.$route.path)
    },
    selectFun(item) {
      let _this = this
      if (!_this.selectedCancer.includes(item)) {
        _this.$axios.get(
            'http://' + _this.$global.serverIP + ':' + _this.$global.serverHost + '/datasets/' + item)
            .then(function (response) {
              let temp = response.data
              console.log(temp)
              for (let i = 0; i < temp.length; i++) {
                _this.dataset_search_result_list.push(temp[i])
              }
            })
        _this.selectedCancer.push(item) // 判断已选列表中是否存在该id，不是则追加进去
      } else {
        let index = this.selectedCancer.indexOf(item) // 求出当前id的所在位置
        _this.selectedCancer.splice(index, 1) // 否则则删除
        _this.dataset_search_result_list = _this.dataset_search_result_list.filter(temp => {
          return temp.type !== item;
        });
      }
      // console.log(_this.selectedCancer.length)
      if (_this.selectedCancer.length === 0) {
        _this.dataset_search_result_list.length = 0
        document.getElementById('search_result').style.display = 'none';
      } else {
        document.getElementById('search_result').style.display = 'block';
      }
    },
    // 全选、反选
    allFun() {
      if (this.selectedCancer.length === this.cancers.length) {
        this.selectedCancer = [] // 判断是否已全部选中，是则清空已选列表
      } else {
        this.cancers.forEach((item) => {
          if (!this.selectedCancer.includes(item)) {
            this.selectedCancer.push(item) // 否则将未选中的全部加入已选列表中
          }
        })
      }
    },
    gotoDetails(DETAILS) {
      return 'https://pubmed.ncbi.nlm.nih.gov/' + DETAILS + '/'
    },
    handleClick(tab) {
      console.log(tab.name)
      if (tab.name === "third" || tab.name === "fourth" || tab.name === "fifth" || tab.name === "seventh") {
        this.showChart = true
      } else {
        this.showChart = false
      }
      if (tab.name === "gene-level") {
        this.key_gene = 'gene' + this.key_submit_num
      } else if (tab.name === "cell-level") {
        this.key_cell = 'cell' + this.key_submit_num
      } else if (tab.name === "cancer-level") {
        this.key_cancer = 'cancer' + this.key_submit_num
      }
      if (tab.name === "fourth") {
        this.key_marker = 'marker' + this.key_submit_num
      } else if (tab.name === "third") {
        this.key_svg = 'svg' + this.key_submit_num
      } else if (tab.name === "fifth") {
        this.key_celltype = 'celltype' + this.key_submit_num
      } else if (tab.name === "sixth") {
        this.key_cnv = 'cnv' + this.key_submit_num
      } else if (tab.name === "seventh") {
        this.key_state = 'state' + this.key_submit_num
      }
      // _this.key_overview = +new Date()
      // _this.key_marker = +new Date()
      // _this.key_svg = +new Date()
      // _this.key_celltype = +new Date()
      // _this.key_cnv = +new Date()
      // _this.key_state = +new Date()
    },
    click_submit() {
      let _this = this
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      _this.key_submit_num += 1
      _this.getGroundTruth()
      _this.showDatasetDetail = true
      _this.getAnnoAndPositionData().then(function () {
        // _this.loadChart = true
        _this.showChart = false
        _this.key_AllLabelChart = 'AllLabelChart' + _this.key_submit_num
        _this.key_overview = 'overview' + _this.key_submit_num
        // _this.key_marker = 'marker' + _this.key_submit_num
        // _this.key_svg = 'svg' + _this.key_submit_num
        // _this.key_celltype = 'celltype' + _this.key_submit_num
        // _this.key_cnv = 'cnv' + _this.key_submit_num
        // _this.key_state = 'state' + _this.key_submit_num
        _this.activeName = 'first'
        loading.close();
      }).catch(function () {
        _this.$message.error('Sorry, this dataset is a work in progress!')
        _this.showDatasetDetail = false
        loading.close();
      })
      // let scrollEle = this.$refs.scrollDiv
      // scrollEle.scrollTo({top: scrollEle.scrollHeight, behavior: 'smooth'})
      // document.getElementById("dataset_detail").scrollIntoView()
      // document.getElementById("{`tab-${first}`}").click()
      // this.activeName = 'third'
    },
    click_compare() {
      this.showDatasetCompare = true
      this.refresh_tag_compare = +new Date()
    },
    scrollToBottom() {
      document.getElementById('dataset_detail').scrollIntoView(false)
      // window.scrollTo(0, document.documentElement.scrollHeight)
    },
    handleSelectionChange(val) {
      this.selectedDataset = val
      // console.log(this.selectedDataset)
      if (this.selectedDataset.length === 0) {
        document.getElementById('disable_button').style.display = 'block';
        document.getElementById('search_result_button_submit').style.display = 'none';
        document.getElementById('search_result_button_compare').style.display = 'none';
        this.activeName = ''
        this.showDatasetDetail = false
        this.showDatasetCompare = false
      } else if (this.selectedDataset.length === 1) {
        document.getElementById('disable_button').style.display = 'none';
        document.getElementById('search_result_button_submit').style.display = 'block';
        document.getElementById('search_result_button_compare').style.display = 'none';
        this.showDatasetCompare = false
      } else {
        document.getElementById('disable_button').style.display = 'none';
        document.getElementById('search_result_button_submit').style.display = 'none';
        document.getElementById('search_result_button_compare').style.display = 'block';
        this.activeName = ''
        this.showDatasetDetail = false
      }
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.currentPage = 1;
      this.pageSize = val;
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentPage = val;
    },
    showOrHide() {
      // console.log("before:"+this.showIntroduction)
      if (this.showIntroduction === false) {
        this.showIntroduction = true
        this.icon_path = require('../../assets/hide.png')
        // this.datasetDetail_tip = 'hide'
      } else {
        this.showIntroduction = false
        this.icon_path = require('../../assets/show.png')
        // this.datasetDetail_tip = 'show'
      }
      // console.log("after:"+this.showIntroduction)
    },
    clearData() {
      this.echart_info = {
        classification_info: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        },
        annot_type_info: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        },
        fine_annot_type_info: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        },
        celltype_info: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        },
        major_info: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        },
        minor_info: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        },
        subset_info: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        }
      }
      this.groundtruth = ''
    },
    initEchartsInfoLabel(haveAnno, haveFineAnno, haveClassification) {
      let _this = this
      let temp_Anno;
      let temp_FineAnno;
      let temp_types_classification;
      if (haveAnno) {
        temp_Anno = []
        _this.echart_info.annot_type_info.source.push(['type', 'x', 'y'])
      }
      if (haveFineAnno) {
        temp_FineAnno = []
        _this.echart_info.fine_annot_type_info.source.push(['type', 'x', 'y'])
      }
      if (haveClassification) {
        temp_types_classification = []
        _this.echart_info.classification_info.source.push(['type', 'x', 'y'])
      }
      for (let i = 0; i < _this.data.length; i++) {
        let index = _this.position.findIndex(item => item.spot === _this.data[i].spot)
        if (index !== -1 && _this.position[index].x !== '' && _this.position[index].x !== null) {
          if (haveAnno) {
            _this.echart_info.annot_type_info.source.push([_this.data[i].annot_type, _this.position[index].x, _this.position[index].y])
          }
          if (haveFineAnno) {
            _this.echart_info.fine_annot_type_info.source.push([_this.data[i].fine_annot_type, _this.position[index].x, _this.position[index].y])
          }
          if (haveClassification) {
            _this.echart_info.classification_info.source.push([_this.data[i].Classification, _this.position[index].x, _this.position[index].y])
          }

          if (haveAnno && !temp_Anno.includes(_this.data[i].annot_type)) {
            temp_Anno.push(_this.data[i].annot_type)
          }
          if (haveFineAnno && !temp_FineAnno.includes(_this.data[i].fine_annot_type)) {
            temp_FineAnno.push(_this.data[i].fine_annot_type)
          }
          if (haveClassification && !temp_types_classification.includes(_this.data[i].Classification)) {
            temp_types_classification.push(_this.data[i].Classification)
          }
        }
      }
      if (_this.data.length > 1000) {
        _this.echart_info.annot_type_info.spotSize = 2
        _this.echart_info.fine_annot_type_info.spotSize = 2
        _this.echart_info.classification_info.spotSize = 2
      } else {
        _this.echart_info.annot_type_info.spotSize = 4
        _this.echart_info.fine_annot_type_info.spotSize = 4
        _this.echart_info.classification_info.spotSize = 4
      }
      if (haveAnno) {
        _this.echart_info.annot_type_info.types = temp_Anno
        for (let i = 0; i < _this.echart_info.annot_type_info.types.length; i++) {
          _this.echart_info.annot_type_info.tip.push({
            value: _this.echart_info.annot_type_info.types[i],
            label: _this.echart_info.annot_type_info.types[i],
            color: _this.COLOR_ALL[i]
          })
        }
      }
      if (haveFineAnno) {
        _this.echart_info.fine_annot_type_info.types = temp_FineAnno
        for (let i = 0; i < _this.echart_info.fine_annot_type_info.types.length; i++) {
          _this.echart_info.fine_annot_type_info.tip.push({
            value: _this.echart_info.fine_annot_type_info.types[i],
            label: _this.echart_info.fine_annot_type_info.types[i],
            color: _this.COLOR_ALL[i]
          })
        }
      }
      if (haveClassification) {
        _this.echart_info.classification_info.types = temp_types_classification
        for (let i = 0; i < _this.echart_info.classification_info.types.length; i++) {
          _this.echart_info.classification_info.tip.push({
            value: _this.echart_info.classification_info.types[i],
            label: _this.echart_info.classification_info.types[i],
            color: _this.COLOR_ALL[i]
          })
        }
      }
      // console.log(_this.echart_info.classification_info.tip)
    },
    initEchartsInfoPre(haveCelltype, haveMajor, haveMinor, haveSubset) {
      let _this = this
      let temp_Celltype;
      let temp_Major;
      let temp_Minor;
      let temp_Subset;
      if (haveCelltype) {
        temp_Celltype = []
        _this.echart_info.celltype_info.source.push(['type', 'x', 'y'])
      }
      if (haveMajor) {
        temp_Major = []
        _this.echart_info.major_info.source.push(['type', 'x', 'y'])
      }
      if (haveMinor) {
        temp_Minor = []
        _this.echart_info.minor_info.source.push(['type', 'x', 'y'])
      }
      if (haveSubset) {
        temp_Subset = []
        _this.echart_info.subset_info.source.push(['type', 'x', 'y'])
      }
      for (let i = 0; i < _this.data.length; i++) {
        let index = _this.position.findIndex(item => item.spot === _this.data[i].spot)
        if (index !== -1 && _this.position[index].x !== '' && _this.position[index].x !== null) {
          if (haveCelltype) {
            _this.echart_info.celltype_info.source.push([_this.data[i].celltype, _this.position[index].x, _this.position[index].y])
          }
          if (haveMajor) {
            _this.echart_info.major_info.source.push([_this.data[i].celltype_major, _this.position[index].x, _this.position[index].y])
          }
          if (haveMinor) {
            _this.echart_info.minor_info.source.push([_this.data[i].celltype_minor, _this.position[index].x, _this.position[index].y])
          }
          if (haveSubset) {
            _this.echart_info.subset_info.source.push([_this.data[i].celltype_subset, _this.position[index].x, _this.position[index].y])
          }

          if (haveCelltype && !temp_Celltype.includes(_this.data[i].celltype)) {
            temp_Celltype.push(_this.data[i].celltype)
          }
          if (haveMajor && !temp_Major.includes(_this.data[i].celltype_major)) {
            temp_Major.push(_this.data[i].celltype_major)
          }
          if (haveMinor && !temp_Minor.includes(_this.data[i].celltype_minor)) {
            temp_Minor.push(_this.data[i].celltype_minor)
          }
          if (haveSubset && !temp_Subset.includes(_this.data[i].celltype_subset)) {
            temp_Subset.push(_this.data[i].celltype_subset)
          }
        }
      }
      if (_this.data.length > 1000) {
        _this.echart_info.celltype_info.spotSize = 2
        _this.echart_info.major_info.spotSize = 2
        _this.echart_info.minor_info.spotSize = 2
        _this.echart_info.subset_info.spotSize = 2
      } else {
        _this.echart_info.celltype_info.spotSize = 4
        _this.echart_info.major_info.spotSize = 4
        _this.echart_info.minor_info.spotSize = 4
        _this.echart_info.subset_info.spotSize = 4
      }
      if (haveCelltype) {
        _this.echart_info.celltype_info.types = temp_Celltype
        for (let i = 0; i < _this.echart_info.celltype_info.types.length; i++) {
          _this.echart_info.celltype_info.tip.push({
            value: _this.echart_info.celltype_info.types[i],
            label: _this.echart_info.celltype_info.types[i],
            color: _this.COLOR_ALL[i]
          })
        }
      }
      if (haveMajor) {
        _this.echart_info.major_info.types = temp_Major
        for (let i = 0; i < _this.echart_info.major_info.types.length; i++) {
          _this.echart_info.major_info.tip.push({
            value: _this.echart_info.major_info.types[i],
            label: _this.echart_info.major_info.types[i],
            color: _this.COLOR_ALL[i]
          })
        }
      }
      if (haveMinor) {
        _this.echart_info.minor_info.types = temp_Minor
        for (let i = 0; i < _this.echart_info.minor_info.types.length; i++) {
          _this.echart_info.minor_info.tip.push({
            value: _this.echart_info.minor_info.types[i],
            label: _this.echart_info.minor_info.types[i],
            color: _this.COLOR_ALL[i]
          })
        }
      }
      if (haveSubset) {
        _this.echart_info.subset_info.types = temp_Subset
        for (let i = 0; i < _this.echart_info.subset_info.types.length; i++) {
          _this.echart_info.subset_info.tip.push({
            value: _this.echart_info.subset_info.types[i],
            label: _this.echart_info.subset_info.types[i],
            color: _this.COLOR_ALL[i]
          })
        }
      }
      // console.log(_this.echart_info.classification_info.tip)
    },
    initEchartsInfoWithPosition(haveAnno, haveFineAnno, haveClassification, haveCelltype, haveMajor, haveMinor, haveSubset){
      console.log("initEchartsInfoWithPosition")
      let _this = this
      let temp_Anno;
      let temp_FineAnno;
      let temp_types_classification;
      if (haveAnno) {
        temp_Anno = []
        _this.echart_info.annot_type_info.source.push(['type', 'x', 'y'])
      }
      if (haveFineAnno) {
        temp_FineAnno = []
        _this.echart_info.fine_annot_type_info.source.push(['type', 'x', 'y'])
      }
      if (haveClassification) {
        temp_types_classification = []
        _this.echart_info.classification_info.source.push(['type', 'x', 'y'])
      }
      for (let i = 0; i < _this.data.length; i++) {
        if (haveAnno) {
          _this.echart_info.annot_type_info.source.push([_this.data[i].annot_type, _this.data[i].x, _this.data[i].y])
        }
        if (haveFineAnno) {
          _this.echart_info.fine_annot_type_info.source.push([_this.data[i].fine_annot_type, _this.data[i].x, _this.data[i].y])
        }
        if (haveClassification) {
          _this.echart_info.classification_info.source.push([_this.data[i].Classification, _this.data[i].x, _this.data[i].y])
        }

        if (haveAnno && !temp_Anno.includes(_this.data[i].annot_type)) {
          temp_Anno.push(_this.data[i].annot_type)
        }
        if (haveFineAnno && !temp_FineAnno.includes(_this.data[i].fine_annot_type)) {
          temp_FineAnno.push(_this.data[i].fine_annot_type)
        }
        if (haveClassification && !temp_types_classification.includes(_this.data[i].Classification)) {
          temp_types_classification.push(_this.data[i].Classification)
        }
      }
      if (_this.data.length > 1000) {
        _this.echart_info.annot_type_info.spotSize = 2
        _this.echart_info.fine_annot_type_info.spotSize = 2
        _this.echart_info.classification_info.spotSize = 2
      } else {
        _this.echart_info.annot_type_info.spotSize = 4
        _this.echart_info.fine_annot_type_info.spotSize = 4
        _this.echart_info.classification_info.spotSize = 4
      }
      if (haveAnno) {
        _this.echart_info.annot_type_info.types = temp_Anno
        for (let i = 0; i < _this.echart_info.annot_type_info.types.length; i++) {
          _this.echart_info.annot_type_info.tip.push({
            value: _this.echart_info.annot_type_info.types[i],
            label: _this.echart_info.annot_type_info.types[i],
            color: _this.COLOR_ALL[i]
          })
        }
      }
      if (haveFineAnno) {
        _this.echart_info.fine_annot_type_info.types = temp_FineAnno
        for (let i = 0; i < _this.echart_info.fine_annot_type_info.types.length; i++) {
          _this.echart_info.fine_annot_type_info.tip.push({
            value: _this.echart_info.fine_annot_type_info.types[i],
            label: _this.echart_info.fine_annot_type_info.types[i],
            color: _this.COLOR_ALL[i]
          })
        }
      }
      if (haveClassification) {
        _this.echart_info.classification_info.types = temp_types_classification
        for (let i = 0; i < _this.echart_info.classification_info.types.length; i++) {
          _this.echart_info.classification_info.tip.push({
            value: _this.echart_info.classification_info.types[i],
            label: _this.echart_info.classification_info.types[i],
            color: _this.COLOR_ALL[i]
          })
        }
      }
      let temp_Celltype;
      let temp_Major;
      let temp_Minor;
      let temp_Subset;
      if (haveCelltype) {
        temp_Celltype = []
        _this.echart_info.celltype_info.source.push(['type', 'x', 'y'])
      }
      if (haveMajor) {
        temp_Major = []
        _this.echart_info.major_info.source.push(['type', 'x', 'y'])
      }
      if (haveMinor) {
        temp_Minor = []
        _this.echart_info.minor_info.source.push(['type', 'x', 'y'])
      }
      if (haveSubset) {
        temp_Subset = []
        _this.echart_info.subset_info.source.push(['type', 'x', 'y'])
      }
      for (let i = 0; i < _this.data.length; i++) {
        if (haveCelltype) {
          _this.echart_info.celltype_info.source.push([_this.data[i].celltype, _this.data[i].x, _this.data[i].y])
        }
        if (haveMajor) {
          _this.echart_info.major_info.source.push([_this.data[i].celltype_major, _this.data[i].x, _this.data[i].y])
        }
        if (haveMinor) {
          _this.echart_info.minor_info.source.push([_this.data[i].celltype_minor, _this.data[i].x, _this.data[i].y])
        }
        if (haveSubset) {
          _this.echart_info.subset_info.source.push([_this.data[i].celltype_subset, _this.data[i].x, _this.data[i].y])
        }

        if (haveCelltype && !temp_Celltype.includes(_this.data[i].celltype)) {
          temp_Celltype.push(_this.data[i].celltype)
        }
        if (haveMajor && !temp_Major.includes(_this.data[i].celltype_major)) {
          temp_Major.push(_this.data[i].celltype_major)
        }
        if (haveMinor && !temp_Minor.includes(_this.data[i].celltype_minor)) {
          temp_Minor.push(_this.data[i].celltype_minor)
        }
        if (haveSubset && !temp_Subset.includes(_this.data[i].celltype_subset)) {
          temp_Subset.push(_this.data[i].celltype_subset)
        }
      }
      if (_this.data.length > 1000) {
        _this.echart_info.celltype_info.spotSize = 2
        _this.echart_info.major_info.spotSize = 2
        _this.echart_info.minor_info.spotSize = 2
        _this.echart_info.subset_info.spotSize = 2
      } else {
        _this.echart_info.celltype_info.spotSize = 4
        _this.echart_info.major_info.spotSize = 4
        _this.echart_info.minor_info.spotSize = 4
        _this.echart_info.subset_info.spotSize = 4
      }
      if (haveCelltype) {
        _this.echart_info.celltype_info.types = temp_Celltype
        for (let i = 0; i < _this.echart_info.celltype_info.types.length; i++) {
          _this.echart_info.celltype_info.tip.push({
            value: _this.echart_info.celltype_info.types[i],
            label: _this.echart_info.celltype_info.types[i],
            color: _this.COLOR_ALL[i]
          })
        }
      }
      console.log("celltype")
      console.log(_this.echart_info.celltype_info)
      if (haveMajor) {
        _this.echart_info.major_info.types = temp_Major
        for (let i = 0; i < _this.echart_info.major_info.types.length; i++) {
          _this.echart_info.major_info.tip.push({
            value: _this.echart_info.major_info.types[i],
            label: _this.echart_info.major_info.types[i],
            color: _this.COLOR_ALL[i]
          })
        }
      }
      if (haveMinor) {
        _this.echart_info.minor_info.types = temp_Minor
        for (let i = 0; i < _this.echart_info.minor_info.types.length; i++) {
          _this.echart_info.minor_info.tip.push({
            value: _this.echart_info.minor_info.types[i],
            label: _this.echart_info.minor_info.types[i],
            color: _this.COLOR_ALL[i]
          })
        }
      }
      if (haveSubset) {
        _this.echart_info.subset_info.types = temp_Subset
        for (let i = 0; i < _this.echart_info.subset_info.types.length; i++) {
          _this.echart_info.subset_info.tip.push({
            value: _this.echart_info.subset_info.types[i],
            label: _this.echart_info.subset_info.types[i],
            color: _this.COLOR_ALL[i]
          })
        }
      }
    },
    initEchartsInfo(haveAnno, haveFineAnno, haveClassification, haveCelltype, haveMajor, haveMinor, haveSubset) {
      console.log("initEchartsInfo")
      let _this = this
      let temp_Anno;
      let temp_FineAnno;
      let temp_types_classification;
      if (haveAnno) {
        temp_Anno = []
        _this.echart_info.annot_type_info.source.push(['type', 'x', 'y'])
      }
      if (haveFineAnno) {
        temp_FineAnno = []
        _this.echart_info.fine_annot_type_info.source.push(['type', 'x', 'y'])
      }
      if (haveClassification) {
        temp_types_classification = []
        _this.echart_info.classification_info.source.push(['type', 'x', 'y'])
      }
      for (let i = 0; i < _this.data.length; i++) {
        let index = _this.position.findIndex(item => item.spot === _this.data[i].spot)
        if (index !== -1 && _this.position[index].x !== '' && _this.position[index].x !== null) {
          if (haveAnno) {
            _this.echart_info.annot_type_info.source.push([_this.data[i].annot_type, _this.position[index].x, _this.position[index].y])
          }
          if (haveFineAnno) {
            _this.echart_info.fine_annot_type_info.source.push([_this.data[i].fine_annot_type, _this.position[index].x, _this.position[index].y])
          }
          if (haveClassification) {
            _this.echart_info.classification_info.source.push([_this.data[i].Classification, _this.position[index].x, _this.position[index].y])
          }

          if (haveAnno && !temp_Anno.includes(_this.data[i].annot_type)) {
            temp_Anno.push(_this.data[i].annot_type)
          }
          if (haveFineAnno && !temp_FineAnno.includes(_this.data[i].fine_annot_type)) {
            temp_FineAnno.push(_this.data[i].fine_annot_type)
          }
          if (haveClassification && !temp_types_classification.includes(_this.data[i].Classification)) {
            temp_types_classification.push(_this.data[i].Classification)
          }
        }
      }
      if (_this.data.length > 1000) {
        _this.echart_info.annot_type_info.spotSize = 2
        _this.echart_info.fine_annot_type_info.spotSize = 2
        _this.echart_info.classification_info.spotSize = 2
      } else {
        _this.echart_info.annot_type_info.spotSize = 4
        _this.echart_info.fine_annot_type_info.spotSize = 4
        _this.echart_info.classification_info.spotSize = 4
      }
      if (haveAnno) {
        _this.echart_info.annot_type_info.types = temp_Anno
        for (let i = 0; i < _this.echart_info.annot_type_info.types.length; i++) {
          _this.echart_info.annot_type_info.tip.push({
            value: _this.echart_info.annot_type_info.types[i],
            label: _this.echart_info.annot_type_info.types[i],
            color: _this.COLOR_ALL[i]
          })
        }
      }
      if (haveFineAnno) {
        _this.echart_info.fine_annot_type_info.types = temp_FineAnno
        for (let i = 0; i < _this.echart_info.fine_annot_type_info.types.length; i++) {
          _this.echart_info.fine_annot_type_info.tip.push({
            value: _this.echart_info.fine_annot_type_info.types[i],
            label: _this.echart_info.fine_annot_type_info.types[i],
            color: _this.COLOR_ALL[i]
          })
        }
      }
      if (haveClassification) {
        _this.echart_info.classification_info.types = temp_types_classification
        for (let i = 0; i < _this.echart_info.classification_info.types.length; i++) {
          _this.echart_info.classification_info.tip.push({
            value: _this.echart_info.classification_info.types[i],
            label: _this.echart_info.classification_info.types[i],
            color: _this.COLOR_ALL[i]
          })
        }
      }
      let temp_Celltype;
      let temp_Major;
      let temp_Minor;
      let temp_Subset;
      if (haveCelltype) {
        temp_Celltype = []
        _this.echart_info.celltype_info.source.push(['type', 'x', 'y'])
      }
      if (haveMajor) {
        temp_Major = []
        _this.echart_info.major_info.source.push(['type', 'x', 'y'])
      }
      if (haveMinor) {
        temp_Minor = []
        _this.echart_info.minor_info.source.push(['type', 'x', 'y'])
      }
      if (haveSubset) {
        temp_Subset = []
        _this.echart_info.subset_info.source.push(['type', 'x', 'y'])
      }
      for (let i = 0; i < _this.data.length; i++) {
        let index = _this.position.findIndex(item => item.spot === _this.data[i].spot)
        if (index !== -1 && _this.position[index].x !== '' && _this.position[index].x !== null) {
          if (haveCelltype) {
            _this.echart_info.celltype_info.source.push([_this.data[i].celltype, _this.position[index].x, _this.position[index].y])
          }
          if (haveMajor) {
            _this.echart_info.major_info.source.push([_this.data[i].celltype_major, _this.position[index].x, _this.position[index].y])
          }
          if (haveMinor) {
            _this.echart_info.minor_info.source.push([_this.data[i].celltype_minor, _this.position[index].x, _this.position[index].y])
          }
          if (haveSubset) {
            _this.echart_info.subset_info.source.push([_this.data[i].celltype_subset, _this.position[index].x, _this.position[index].y])
          }

          if (haveCelltype && !temp_Celltype.includes(_this.data[i].celltype)) {
            temp_Celltype.push(_this.data[i].celltype)
          }
          if (haveMajor && !temp_Major.includes(_this.data[i].celltype_major)) {
            temp_Major.push(_this.data[i].celltype_major)
          }
          if (haveMinor && !temp_Minor.includes(_this.data[i].celltype_minor)) {
            temp_Minor.push(_this.data[i].celltype_minor)
          }
          if (haveSubset && !temp_Subset.includes(_this.data[i].celltype_subset)) {
            temp_Subset.push(_this.data[i].celltype_subset)
          }
        }
      }
      if (_this.data.length > 1000) {
        _this.echart_info.celltype_info.spotSize = 2
        _this.echart_info.major_info.spotSize = 2
        _this.echart_info.minor_info.spotSize = 2
        _this.echart_info.subset_info.spotSize = 2
      } else {
        _this.echart_info.celltype_info.spotSize = 4
        _this.echart_info.major_info.spotSize = 4
        _this.echart_info.minor_info.spotSize = 4
        _this.echart_info.subset_info.spotSize = 4
      }
      if (haveCelltype) {
        _this.echart_info.celltype_info.types = temp_Celltype
        for (let i = 0; i < _this.echart_info.celltype_info.types.length; i++) {
          _this.echart_info.celltype_info.tip.push({
            value: _this.echart_info.celltype_info.types[i],
            label: _this.echart_info.celltype_info.types[i],
            color: _this.COLOR_ALL[i]
          })
        }
      }
      console.log("celltype")
      console.log(_this.echart_info.celltype_info)
      if (haveMajor) {
        _this.echart_info.major_info.types = temp_Major
        for (let i = 0; i < _this.echart_info.major_info.types.length; i++) {
          _this.echart_info.major_info.tip.push({
            value: _this.echart_info.major_info.types[i],
            label: _this.echart_info.major_info.types[i],
            color: _this.COLOR_ALL[i]
          })
        }
      }
      if (haveMinor) {
        _this.echart_info.minor_info.types = temp_Minor
        for (let i = 0; i < _this.echart_info.minor_info.types.length; i++) {
          _this.echart_info.minor_info.tip.push({
            value: _this.echart_info.minor_info.types[i],
            label: _this.echart_info.minor_info.types[i],
            color: _this.COLOR_ALL[i]
          })
        }
      }
      if (haveSubset) {
        _this.echart_info.subset_info.types = temp_Subset
        for (let i = 0; i < _this.echart_info.subset_info.types.length; i++) {
          _this.echart_info.subset_info.tip.push({
            value: _this.echart_info.subset_info.types[i],
            label: _this.echart_info.subset_info.types[i],
            color: _this.COLOR_ALL[i]
          })
        }
      }
    },
    initEchartsInfo1Celltype() {
      let _this = this
      let temp_types_classification = []
      let temp_types_celltype = []
      _this.echart_info.classification_info.source.push(['type', 'x', 'y'])
      _this.echart_info.celltype_info.source.push(['type', 'x', 'y'])
      for (let i = 0; i < _this.data.length; i++) {
        let index = _this.position.findIndex(item => item.spot === _this.data[i].spot)
        if (index !== -1 && _this.position[index].x !== '' && _this.position[index].x !== null) {
          _this.echart_info.classification_info.source.push([_this.data[i].Classification, _this.position[index].x, _this.position[index].y])
          _this.echart_info.celltype_info.source.push([_this.data[i].celltype, _this.position[index].x, _this.position[index].y])


          if (!temp_types_classification.includes(_this.data[i].Classification)) {
            temp_types_classification.push(_this.data[i].Classification)
          }
          if (!temp_types_celltype.includes(_this.data[i].celltype)) {
            temp_types_celltype.push(_this.data[i].celltype)
          }
        }
      }
      // console.log(_this.echart_info.classification_info.source)
      _this.echart_info.classification_info.types = temp_types_classification
      _this.echart_info.celltype_info.types = temp_types_celltype
      if (_this.data.length > 1000) {
        _this.echart_info.classification_info.spotSize = 2
        _this.echart_info.celltype_info.spotSize = 2
        _this.echart_info.major_info.spotSize = 2
        _this.echart_info.minor_info.spotSize = 2
        _this.echart_info.subset_info.spotSize = 2
      } else {
        _this.echart_info.classification_info.spotSize = 4
        _this.echart_info.celltype_info.spotSize = 4
        _this.echart_info.major_info.spotSize = 4
        _this.echart_info.minor_info.spotSize = 4
        _this.echart_info.subset_info.spotSize = 4
      }
      for (let i = 0; i < _this.echart_info.classification_info.types.length; i++) {
        _this.echart_info.classification_info.tip.push({
          value: _this.echart_info.classification_info.types[i],
          label: _this.echart_info.classification_info.types[i],
          color: _this.COLOR_ALL[i]
        })
      }
      for (let i = 0; i < _this.echart_info.celltype_info.types.length; i++) {
        _this.echart_info.celltype_info.tip.push({
          value: _this.echart_info.celltype_info.types[i],
          label: _this.echart_info.celltype_info.types[i],
          color: _this.COLOR_ALL[i]
        })
      }
    },
    handleCommand(command) {
      this.$message.info(command)
      if (command === 'svg') {
        this.show_marker = false;
        this.show_svg = true
      }
      else {
        this.show_marker = true;
        this.show_svg = false
      }
    },
    handleCommand2(command) {
      if (command === 'cnv') {
        this.show_celltype = true
      }
      else {
        this.show_celltype = true
      }
    },
    handleCommand3(command) {
      console.log(command)
      if (command === 'state') {
        console.log('state')
        this.show_cnv = false
        this.show_state = true
        this.show_immune = false
        this.showChart = false
        this.show_tls = false
      }else if (command === 'immune') {
        console.log('immune')
        this.show_cnv = false
        this.show_state = false
        this.show_immune = true
        this.showChart = false
        this.show_tls = false
      }else if (command === 'tls') {
        console.log('tls')
        this.show_cnv = false
        this.show_state = false
        this.show_immune = false
        this.showChart = false
        this.show_tls = true
      } else {
        console.log('cnv')
        this.show_cnv = true
        this.show_state = false
        this.show_immune = false
        this.showChart = false
        this.show_tls = false
      }
    },
  }
}
</script>

<style scoped>
#scrollDiv {
  margin-top: 10px;
  margin-bottom: 10px;
}

#dataset_introduce {
  position: relative;
}

.introduction {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.left_introduction {
  width: 20%;
  min-width: 200px;
  height: 500px;
  overflow: auto;
  position: relative;
  display: flex;
  flex-direction: column;
  /*margin-top: 10px;*/
}

.right_introduction {
  flex: 1;
  height: 500px;
  margin: 0 0 0 5px;
  padding: 0;
  background-color: #FFFFFF;
  overflow-y: auto;
  /*display: flex;*/
  /*flex-direction: column;*/
  /*align-items: flex-end;*/
  /*justify-content: flex-end;*/
  /*margin-right: 10px;*/
}

#cancer_checkbox {
  margin-top: 10px;
  padding: 0 0 10px 0;
  background-color: #FFFFFF;
}

#search_result {
  display: none;
}

.CheckBox {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  /*padding: 20px;*/
  padding-left: 20px;
  margin: 20px auto;
}

.CheckItem {
  display: flex;
  width: 170px;
  margin: 0 10px 10px 0;
  align-items: center;
}

.select {
  width: 20px;
  height: 20px;
  border-radius: 2px;
  border: 1px solid #ccc;
  display: flex;
  justify-content: center;
  cursor: pointer;
  margin-right: 10px;
  align-items: center;
}

.selectActv::before {
  display: block;
  content: "";
  width: 5px;
  height: 12px;
  border-bottom: 2px solid #3F78C1;
  border-right: 2px solid #3F78C1;
  transform: rotate(45deg);
}

.selectAll {
  display: flex;
}

#dataset_detail {

  background-color: #FFFFFF;
}

#dataset_detail /deep/ .el-tabs__item {
  font-size: 16px;
  color: #000000 !important;
}

/* 切换活动项的文字颜色 */
#dataset_detail /deep/ .el-tabs__item.is-active {
  font-size: 16px;
  font-weight: bold;
  color: #3F78C1 !important;
}

#dataset_detail /deep/ .el-tabs__item:hover {
  font-weight: bold;
}

#search_result_button_submit {
  color: #FFFFFF;
  background-color: #173161;
}

#search_result_button_compare {
  color: #FFFFFF;
  background-color: #173161;
}

#disable_button {
  color: #FFFFFF;
  background-color: #173161;
}
</style>
